import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "../../../assets/styles/OpportunityModal.css";
import OpportunityModalHeader from "./OpportunityModalHeader";
import OpportunityModalBody from "./OpportunityModalBody";
import useOpportunityModal from "../../../hooks/useOpportunityModal";

const OpportunityModal = ({
  show,
  handleClose,
  project,
  towerInfo,
  towerList,
  setTowerInfo,
  formattedTowerData,
  setformattedTowerData,
  modalLoading,
  onChange,
  towerId,
  initialSerialNumber,
}) => {
  const {
    scopeOfWork,
    selectedSerialNumber,
    setSelectedSerialNumber,
    modalState,
    handleTabClick,
  } = useOpportunityModal(towerList, setTowerInfo);

  // Add useEffect to synchronize selectedSerialNumber with towerInfo
  useEffect(() => {
    if (initialSerialNumber) {
      console.log("Setting selectedSerialNumber to initialSerialNumber:", initialSerialNumber);
      setSelectedSerialNumber(initialSerialNumber);
    }
  }, [towerInfo, setSelectedSerialNumber]);

  if (!project) return null;
  towerInfo = towerInfo?.towerInfo;

  const renderField = (label, value) => {
    if (value === null || value === undefined || value === "") return null;

    let content;
    if (typeof value === "object" && !Array.isArray(value)) {
      content = JSON.stringify(value, null, 2);
    } else if (Array.isArray(value)) {
      content = value.join(", ");
    } else {
      content = value.toString();
    }

    return (
      <div className="p-1 mb-1" style={{ fontSize: "0.8rem" }}>
        <strong>{label}:</strong> {content}
      </div>
    );
  };

  const handleChange = async (e) => {
    const selectedValue = e.target.value;
    setSelectedSerialNumber(selectedValue);
    
    if (selectedValue === "create_new") {
      onChange(selectedValue);
    } else {
      // Find the selected tower from the list
      const selectedTower = towerList.find(
        tower => tower.towerInfo.generalTowerDescription.serialNumber === selectedValue
      );
      
      if (selectedTower) {
        // Update the formatted tower data with the selected tower's info
        setformattedTowerData(selectedTower.towerInfo);
        onChange(selectedValue);
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Dialog size="xl" className="m-0">
        <OpportunityModalHeader
          project={project}
          renderField={renderField}
          selectedSerialNumber={selectedSerialNumber}
          handleChange={handleChange}
          towerList={towerList}
          formattedTowerData={formattedTowerData}
        />
        <OpportunityModalBody
          modalState={modalState}
          handleTabClick={handleTabClick}
          formattedTowerData={formattedTowerData}
          setformattedTowerData={setformattedTowerData}
          modalLoading={modalLoading}
          scopeOfWork={scopeOfWork}
          towerId={towerId}
          project={project}
          renderField={renderField}
        />
      </Modal.Dialog>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpportunityModal;
